export default "__VITE_ASSET__DglIs3lD__"